import React, { useState, useEffect, useCallback, useRef } from 'react';
import DateSplit from '../widgets/date';
import FileUpladM from '../../../../components/FileUpload/FileUploader';
import AddressFull from './Autocomplete/AddressFull';
import AutocompleteSelect from './Autocomplete/AutocompleteSelect';
import { getBenefits, findKgsPaginated } from '../activity';
import { createAddressObj } from '../helpers/address';
import { loadFileAsBase64 } from '../../../../services/apiClient';
import CustomSelect from './Select';

const curYear = new Date().getFullYear();

const handleFileViewRequest = async (id, fileId) => {
  return await loadFileAsBase64(`requests/${id}/file/${fileId}/benefits`);
};

const InfoDocuments = ({isShow}) =>{
  if(!isShow) return null;

  return (<div className="alert alert-info">
                <strong>Які саме завантажувати документи?</strong>
                <p>
                  Кожний тип пільги може підтверджуватись одним або декільма пов'язаними документами. Після подання заявки, зверніться до управління освіти вашого району з метою підтвердження зазначеної пільги.
                </p>
                
              </div>)

}


const StatusBenefits = ({isShow}) => {

  if(!isShow) return null;

  return (<div className="alert alert-info">
                <strong>Підтверджена пільга. Редагування заборонено.</strong>
              
              </div>)

}


const BenefitDocument = ({ isShow, formData, onChange, errors, disabled }) => {
  if (!isShow) return null;

  return (
    <>
      <div className="form-row-plain two-cols">
        <div className="form-group">
          <label className="form-label">Тип документа</label>
          <input
            type="text"
            className={`form-control ${errors.benefitsDocumentType ? 'is-invalid' : ''}`}
            value={formData.benefits.documentType}
            onChange={(e) => onChange('benefits.documentType', e.target.value)}
            disabled={disabled}
          />
          {errors.benefitsDocumentType && <div className="invalid-feedback">{errors.benefitsDocumentType}</div>}
        </div>
        <div className="form-group">
          <label className="form-label">Номер документа</label>
          <input
            type="text"
            className={`form-control ${errors.benefitsDocumentNumber ? 'is-invalid' : ''}`}
            value={formData.benefits.documentNumber}
            onChange={(e) => onChange('benefits.documentNumber', e.target.value)}
            disabled={disabled}
          />
          {errors.benefitsDocumentNumber && <div className="invalid-feedback">{errors.benefitsDocumentNumber}</div>}
        </div>
      </div>

      <div className="form-row-plain single">
        <div className="form-group">
          <label className="form-label">Кому видано</label>
          <input
            type="text"
            className={`form-control ${errors.benefitsIssuedTo ? 'is-invalid' : ''}`}
            value={formData.benefits.issuedTo}
            onChange={(e) => onChange('benefits.issuedTo', e.target.value)}
            disabled={disabled}
          />
          {errors.benefitsIssuedTo && <div className="invalid-feedback">{errors.benefitsIssuedTo}</div>}
        </div>
      </div>

      <DateSplit
        error={errors.benefitsIssueDate}
        date={formData.benefits.issueDate}
        setDate={(v) => onChange('benefits.issueDate', v)}
        yearFrom={1990}
        yearTo={curYear}
        label="Дата видачі"
        readOnly={disabled}
      />

      <InfoDocuments isShow={!disabled} />

      <FileUpladM
        label="Завантажте фото чи скан-копію документа*"
        value={formData.benefits.files}
        onChange={(files) => onChange('benefits.files', files)}
        multiple={true}
        errorVal={errors.benefitsFiles}
        onFileViewRequest={(fileId) => handleFileViewRequest(formData._id, fileId)}
        editable={!disabled}
      />
    </>
  );
};

const BenefitTerritory = ({ isShow, formData, onChange, errors, kgSelectProps, disabled }) => {
  if (!isShow) return null;
  return (
    <>
      <AutocompleteSelect
        {...kgSelectProps}
        label="Заклад дошкільної освіти"
        placeholder="Оберіть ЗДО"
        className="small"
        fieldsValue={["number", "name"]}
        disabled={disabled}
      />
      <AddressFull
        dictionary={formData.dictionary}
        title="Адреса проживання"
        value={formData.benefits.address}
        fieldsPath="benefits.address"
        onChange={onChange}
        error={errors.benefitsaddress}
        disabled={disabled}
      />
    </>
  );
};

const BenefitSibling = ({ isShow, formData, onChange, errors, kgSelectProps, disabled }) => {
  if (!isShow) return null;
  return (
    <>
      <AutocompleteSelect
        {...kgSelectProps}
        label="Заклад дошкільної освіти"
        placeholder="Оберіть ЗДО"
        className="small"
        fieldsValue={["number", "name"]}
        disabled={disabled}
      />

      <div className="form-row-plain single">
        <div className="form-group">
          <label className="form-label">Номер свідоцтва про народження дитини</label>
          <input
            type="text"
            className={`form-control ${errors.benefitsSiblingBirthCertificate ? 'is-invalid' : ''}`}
            value={formData.benefits.siblingBirthCertificate}
            onChange={(e) => onChange('benefits.siblingBirthCertificate', e.target.value)}
            disabled={disabled}
          />
          {errors.benefitsSiblingBirthCertificate && <div className="invalid-feedback">{errors.benefitsSiblingBirthCertificate}</div>}
        </div>
      </div>

      <div className="form-row-plain single">
        <div className="form-group">
          <label className="form-label">Ім'я дитини, що вже навчається</label>
          <input
            type="text"
            className={`form-control ${errors.benefitsSiblingName ? 'is-invalid' : ''}`}
            value={formData.benefits.siblingName}
            onChange={(e) => onChange('benefits.siblingName', e.target.value)}
            disabled={disabled}
          />
          {errors.benefitsSiblingName && <div className="invalid-feedback">{errors.benefitsSiblingName}</div>}
        </div>
      </div>

      <DateSplit
        error={errors.benefitsSiblingBirthDate}
        date={formData.benefits.siblingBirthDate}
        setDate={(v) => onChange('benefits.siblingBirthDate', v)}
        yearFrom={2010}
        yearTo={curYear}
        label="Дата народження дитини"
        readOnly={disabled}
      />
    </>
  );
};

const BenefitEmployee = ({ isShow, formData, onChange, errors, kgSelectProps, disabled }) => {
  if (!isShow) return null;
  return (
    <>
      <AutocompleteSelect
        {...kgSelectProps}
        label="Заклад дошкільної освіти"
        placeholder="Оберіть ЗДО"
        className="small"
        fieldsValue={["number", "name"]}
        disabled={disabled}
      />

      <div className="form-row-plain single">
        <div className="form-group">
          <label className="form-label">Ім'я працівника</label>
          <input
            type="text"
            className={`form-control ${errors.benefitsEmployeeName ? 'is-invalid' : ''}`}
            value={formData.benefits.employeeName}
            onChange={(e) => onChange('benefits.employeeName', e.target.value)}
            disabled={disabled}
          />
          {errors.benefitsEmployeeName && <div className="invalid-feedback">{errors.benefitsEmployeeName}</div>}
        </div>
      </div>

      <div className="form-row-plain single">
        <div className="form-group">
          <label className="form-label">РНОКПП працівника</label>
          <input
            type="text"
            className={`form-control ${errors.benefitsEmployeeRnokpp ? 'is-invalid' : ''}`}
            value={formData.benefits.employeeRnokpp}
            onChange={(e) => onChange('benefits.employeeRnokpp', e.target.value)}
            disabled={disabled}
          />
          {errors.benefitsEmployeeRnokpp && <div className="invalid-feedback">{errors.benefitsEmployeeRnokpp}</div>}
        </div>
      </div>
    </>
  );
};

// ───── главный компонент ─────

const Step4 = ({ formData, onChange, errors }) => {
  const isApproved = formData.benefits.isApproved === true;
  const [benefits, setBenefits] = useState([]);

  const [showDocumentFields,  setShowDocumentFields]  = useState(false);
  const [showTerritoryFields, setShowTerritoryFields] = useState(false);
  const [showSiblingFields,   setShowSiblingFields]   = useState(false);
  const [showEmployeeFields,  setShowEmployeeFields]  = useState(false);

  const [kgItems,       setKgItems]       = useState([]);
  const [kgLoading,     setKgLoading]     = useState(false);
  const [kgLoadingMore, setKgLoadingMore] = useState(false);
  const [kgHasMore,     setKgHasMore]     = useState(true);
  const kgPageRef     = useRef(0);
  const kgSearchRef   = useRef('');
  const kgDebounceRef = useRef(null);

  const fetchKgPage = useCallback(async ({ search, page, append }) => {
    if (page === 0) setKgLoading(true);
    else setKgLoadingMore(true);
    try {
      const result = await findKgsPaginated({ search, page });
      setKgItems(prev => append ? [...prev, ...result.items] : result.items);
      setKgHasMore(result.hasMore);
      kgPageRef.current = page;
    } catch (e) {
      console.error('fetchKgPage error', e);
    } finally {
      setKgLoading(false);
      setKgLoadingMore(false);
    }
  }, []);

  useEffect(() => {
    fetchKgPage({ search: '', page: 0, append: false });
  }, []);

  const handleKgSearch = useCallback((value) => {
    if (kgDebounceRef.current) clearTimeout(kgDebounceRef.current);
    kgSearchRef.current = value;
    kgDebounceRef.current = setTimeout(() => {
      fetchKgPage({ search: value, page: 0, append: false });
    }, 400);
  }, [fetchKgPage]);

  const handleKgLoadMore = useCallback(() => {
    if (kgLoadingMore || !kgHasMore) return;
    fetchKgPage({ search: kgSearchRef.current, page: kgPageRef.current + 1, append: true });
  }, [kgLoadingMore, kgHasMore, fetchKgPage]);

  const kgSelectProps = {
    value:       formData.benefits.kindergarten,
    onChange:    (val) => onChange('benefits.kindergarten', val),
    options:     kgItems,
    loading:     kgLoading,
    loadingMore: kgLoadingMore,
    hasMore:     kgHasMore,
    onSearch:    handleKgSearch,
    onLoadMore:  handleKgLoadMore,
    error:       errors.benefitsKindergarten,
  };

  useEffect(() => {
    getBenefits().then(setBenefits);
  }, []);

  useEffect(() => {
    if (benefits.length < 1) return;
    const selectedBenefit = benefits.find(b => b._id === formData.benefits.type);

    setShowDocumentFields(false);
    setShowTerritoryFields(false);
    setShowSiblingFields(false);
    setShowEmployeeFields(false);

    if (selectedBenefit) {
      const name = selectedBenefit.name.toLowerCase();
      if (name.includes('територія обслуговування')) {
        setShowTerritoryFields(true);
      } else if (name.includes('брати та сестри') || name.includes('сестри в одному здо')) {
        setShowSiblingFields(true);
      } else if (name.includes('працівників закладу') || name.includes('працівників здо')) {
        setShowEmployeeFields(true);
      } else {
        setShowDocumentFields(true);
      }
    }
  }, [formData.benefits.type, benefits]);

  const handleBenefitChange = (value) => {
    onChange('benefits.type', value);
    onChange('benefits.documentType', '');
    onChange('benefits.documentNumber', '');
    onChange('benefits.issuedTo', '');
    onChange('benefits.issueDate', '');
    onChange('benefits.files', []);
    onChange('benefits.address', createAddressObj());
    onChange('benefits.kindergarten', '');
    onChange('benefits.siblingBirthCertificate', '');
    onChange('benefits.siblingName', '');
    onChange('benefits.siblingBirthDate', '');
    onChange('benefits.employeeName', '');
    onChange('benefits.employeeRnokpp', '');
  };

  return (
    <div className="form-section">
      <h2 className="form-section-title">Наявність пільг</h2>

      <StatusBenefits isShow={isApproved}/>

      <div className="form-row-plain single">
        <div className="form-group">
          <label className="form-label">Вид пільги</label>
          <CustomSelect
            value={formData.benefits.type}
            onChange={handleBenefitChange}
            options={[
              { value: '', label: 'Відсутня' },
              ...benefits.map(b => ({ value: b._id, label: b.name }))
            ]}
            placeholder="Відсутня"
            disabled={isApproved}
          />
        </div>
      </div>

      <BenefitDocument
        isShow={showDocumentFields}
        formData={formData}
        onChange={onChange}
        errors={errors}
        disabled={isApproved}
      />

      <BenefitTerritory
        isShow={showTerritoryFields}
        formData={formData}
        onChange={onChange}
        errors={errors}
        kgSelectProps={kgSelectProps}
        disabled={isApproved}
      />

      <BenefitSibling
        isShow={showSiblingFields}
        formData={formData}
        onChange={onChange}
        errors={errors}
        kgSelectProps={kgSelectProps}
        disabled={isApproved}
      />

      <BenefitEmployee
        isShow={showEmployeeFields}
        formData={formData}
        onChange={onChange}
        errors={errors}
        kgSelectProps={kgSelectProps}
        disabled={isApproved}
      />
    </div>
  );
};

export default Step4;